import { useState } from "react";
import { LuImage, LuInfo, LuTag } from "react-icons/lu";
import PageHeader from "src/components/PageHeader";
import ProgressBar from "src/components/StepProgressBar/StepProgressBar";
import WhiteBoard from "src/components/WhiteBoard";
import CategorySelector from "./components/CategorySelector";

export default function AddNewProduct() {
  const [currentStep, setCurrentStep] = useState(0);


  const steps = [
    {
      id: 1,
      title: 'دسته بندی',
      description: 'دسته بندی محصول',
      icon: <LuTag />,
      component: <CategorySelector />
    },
    {
      id: 2,
      title: 'اطلاعات کلی',
      description: 'ویژگی‌ها و مشخصات محصول',
      icon: <LuInfo />,
    },
    {
      id: 3,
      title: 'عکس',
      description: 'تصاویر محصول',
      icon: <LuImage />,
    },
  ];

  const handleStepClick = (stepIndex) => {
    if (stepIndex <= currentStep + 1) {
      setCurrentStep(stepIndex);
    }
  };
  return (
    <>
      <PageHeader
        title="ایجاد محصول جدید"
      />
      <WhiteBoard>
        <ProgressBar
          steps={steps}
          currentStep={currentStep}
          onStepClick={handleStepClick}
          showLabels={true}
        />
        {/* <CategorySelector /> */}
      </WhiteBoard>
    </>

  )
}
